@if (loginOk && !loading) {
  <p-block-ui [blocked]="layoutService.blockDocument()"/>
  <p-toast position="top-right"/>
  <p-confirm-dialog/>
  <!-- Profile Dialog -->
  @if (showProfileDialog) {
    <sps-profile-dialog [activeProfileId]="activeProfileId"
                        [visible]="showProfileDialog"
                        (dialogClose)="showProfileDialog = false">
    </sps-profile-dialog>
  }
  <!-- Topbar Popover Menu (Notifications, Profi...) -->
  @if (i18n.i18nInitialized()) {
    <p-popover #tbmenu
               [ariaLabel]="(activeTopbarMenuOverlay?.type === 'NOTIFICATIONS') ? i18n?.i18nLng()['HEADERNOTIFICATIONSMENU'] : i18n?.i18nLng()['HEADERPROFILEMENU']"
               (onHide)="onTopbarOverlayMenuHide()"
               [style]="{width: '280px'}"
               [focusOnShow]="false">
      @if (activeTopbarMenuOverlay?.type === 'NOTIFICATIONS') {
        <sps-notifications-overlay-menu [notifications]="notificationService.notifications()"></sps-notifications-overlay-menu>
      }
      @if (activeTopbarMenuOverlay?.type === 'PROFILE') {
        <sps-profile-overlay-menu (itemClicked)="onProfileMenuItemClick($event)">
        </sps-profile-overlay-menu>
      }
    </p-popover>
  }
  <!-- Global progress dialog -->
  @if (layoutService.showProgressDialog) {
    <sps-progress-dialog [title]="layoutService.progressDialogTitle"
                         [showProgressSpinner]="layoutService.showProgressSpinner">
    </sps-progress-dialog>
  }

  <!-- Sidebar (voller Viewport, fixiert) -->
  @if (i18n.i18nInitialized() && !loading) {
    <!--
    <nav id="sidebarMenu" class="sidebar"
         [@sidebarExpand]="sidebarState"> -->
    <nav id="sidebarMenu"
         class="sidebar"
         [class.expanded]="layoutService.menuExpanded()"
         [class.collapsed]="!layoutService.menuExpanded()">
      <!-- Sidebar Header (Branding) -->
      <div class="sidebar-header" role="banner">
        <a routerLink="/dashboard" [attr.aria-label]="i18n?.i18nLng()['DASHBOARD']">
          <img src="images/branding/gc_brand.svg" alt="GiroCheckout Logo">
          @if (layoutService.menuExpanded()) {
            <div class="label" [class.visible]="layoutService.menuExpanded()">
              <span>Giro</span>
              <span class="bold">Checkout</span>
            </div>
          }
        </a>
      </div>

      <!-- Sidebar Content -->
      @if (!loading && menuInitialized) {
        <div class="sidebar-content"
             role="navigation"
             [attr.aria-label]="i18n?.i18nLng()['ALMAINNAV']">
          <gc-menu (menuInitialized)="layoutService.sidebarMenu = $event"></gc-menu>
        </div>
      }

      <!-- Sidebar Footer (Toggle Button) -->
      <div class="sidebar-footer">
        <div class="footer-button">
          <p-button
              icon="pi pi-chevron-right"
              variant="outlined"
              severity="secondary"
              size="large"
              (click)="toggleMenu()"
              [style.transform]="layoutService.menuExpanded() ? 'rotate(180deg)' : 'none'"
              aria-label="Menü ein- oder ausklappen"
              [attr.aria-expanded]="layoutService.menuExpanded()"
              [attr.aria-controls]="'sidebarMenu'"
          ></p-button>
        </div>
      </div>
    </nav>
  }

  <!-- Main-Layout -->
  @if (i18n.i18nInitialized() && !loading && !layoutService.refreshContentFlag) {
    <!--
    <main spsMobileDetection
          class="layout-wrapper"
          [@shiftContent]="sidebarState"> -->
    <main spsMobileDetection
          class="layout-wrapper"
          [class.expanded]="layoutService.menuExpanded()"
          [class.collapsed]="!layoutService.menuExpanded()">
      <!-- App Header -->
      <section aria-label="Header" class="app-header" role="banner">
        <div class="header-content">
          <div class="header-item">
            <p-breadcrumb
                [model]="i18n.breadcrumbMenuItems()">
              <ng-template #item let-item>
                <div class="breadcrumb-link">
                  <a [routerLink]="item?.routerLink ? item?.routerLink : null"
                     [attr.aria-label]="item.label"
                     [attr.aria-current]="item?.routerLinkActive ? 'page' : null"
                     [tabindex]="item?.routerLink ? 0 : -1">
                    <div class="breadcrumb-item" [ngClass]="item?.routerLink ? 'active-link' : null">
                      @if (item?.icon) {
                        <i [ngClass]="item.icon"></i>
                      }
                      @if (item?.icon === 'pi pi-home' && layoutService.isMobile()) {
                        <!-- no Home-Label in Mobile-Mode -->
                      } @else {
                        @if (item?.label) {
                          <span [ngClass]="item?.routerLinkActive ? 'active-route-label' : null">{{ item?.i18nLabelKey ? i18n?.i18nLng()[item.i18nLabelKey] : item.label }}</span>
                        }
                      }
                    </div>
                  </a>
                </div>
              </ng-template>
            </p-breadcrumb>
          </div>
          <div class="header-item">
            <div class="topbar-menu">
              <p-toolbar>
                <ng-template #start>
                  <sps-toolbar-item [attr.aria-label]="i18n?.i18nLng()['HEADERNOTIFICATIONSMENU']"
                                    role="button"
                                    tabindex="0"
                                    name="NOTIFICATION"
                                    icon="pi-bell"
                                    i18nTooltipKey="NOTIFICATIONS"
                                    class="mr-4 sps-toolbar-icon"
                                    [showBadge]="true"
                                    [severity]="notificationService.notifications().length === 0 ? 'contrast' : null"
                                    [badgeValue]="notificationService.notifications().length"
                                    (click)="topbarMenuItemClick('NOTIFICATIONS', $event)"
                                    (keydown.enter)="topbarMenuItemClick('NOTIFICATIONS', $event)"
                                    (keydown.space)="topbarMenuItemClick('NOTIFICATIONS', $event)">
                  </sps-toolbar-item>
                  <sps-toolbar-item [attr.aria-label]="i18n?.i18nLng()['HEADERPROFILEMENU']"
                                    role="button"
                                    tabindex="0"
                                    class="sps-toolbar-icon"
                                    name="PROFILE"
                                    [tooltipText]="i18n?.i18nLng()['PROFILE'] + ': ' + authService?.userData?.firstName + ' ' + authService?.userData?.lastName"
                                    icon="AVATAR"
                                    (click)="topbarMenuItemClick('PROFILE', $event)"
                                    (keydown.enter)="topbarMenuItemClick('PROFILE', $event)"
                                    (keydown.space)="topbarMenuItemClick('PROFILE', $event)">
                  </sps-toolbar-item>
                </ng-template>
              </p-toolbar>
            </div>
          </div>
        </div>
      </section>

      <!-- Main-Content -->
      <section [attr.aria-label]="i18n?.i18nLng()['MAINCONTENT']" class="app-body" role="main">
        <div class="content-container">
          <main class="main-content">
            <router-outlet></router-outlet>
          </main>
          <footer aria-label="Footer" class="app-footer" role="contentinfo">
            <div class="footer-branding">
              <img src="images/branding/s-public_logo.svg" alt="S-Public Services Logo">
            </div>
            <div class="footer-content">
              <nav aria-label="Footer Navigation" class="links">
                <!--
                <a tabindex="0" routerLink="/contact" [attr.aria-label]="i18n?.i18nLng()['CONTACTPAGE']">{{ i18n?.i18nLng()['CONTACT'] }}</a>
                <span class="separator">·</span>
                -->
                <!--
                <a tabindex="0" routerLink="/imprint"
                   [attr.aria-label]="i18n?.i18nLng()['IMPRINTPAGE']">{{ i18n?.i18nLng()['IMPRINT'] }}</a>
                <span class="separator">·</span>
                <a tabindex="0" routerLink="/tcs" [attr.aria-label]="i18n?.i18nLng()['T&CPAGE']"><abbr
                    [title]="i18n?.i18nLng()['T&CPAGE']">{{ i18n?.i18nLng()['T&C'] }}</abbr></a>
                <span class="separator">·</span>
                <a tabindex="0" routerLink="/privacy"
                   [attr.aria-label]="i18n?.i18nLng()['PRIVACYPAGE']">{{ i18n?.i18nLng()['PRIVACY'] }}</a>
                   -->
                <a tabindex="0" [href]="imprintUrl" target="_blank"
                   [attr.aria-label]="i18n?.i18nLng()['IMPRINTPAGE']">{{ i18n?.i18nLng()['IMPRINT'] }}</a>
                <span class="separator">·</span>
                <a tabindex="0" [href]="agbUrl" target="_blank" [attr.aria-label]="i18n?.i18nLng()['T&CPAGE']"><abbr
                    [title]="i18n?.i18nLng()['T&CPAGE']">{{ i18n?.i18nLng()['T&C'] }}</abbr></a>
                <span class="separator">·</span>
                <a tabindex="0" [href]="privacyUrl" target="_blank"
                   [attr.aria-label]="i18n?.i18nLng()['PRIVACYPAGE']">{{ i18n?.i18nLng()['PRIVACY'] }}</a>
              </nav>
              <div>
                {{ i18n?.i18nLng()['COPYRIGHT'] }}<span class="ml-3">v{{appVersion}}</span>
              </div>
              @if (versions?.versions.size > 0) {
                <div>
                  @for (version of versions?.versions | keyvalue; track version.key) {
                    <div>
                      {{ version.key }} : {{ version.value }}
                    </div>
                  }
                  <button [cdkCopyToClipboard]=this.versions.formattedVersions>
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
              }
            </div>
          </footer>
        </div>
      </section>
    </main>
  }
}
